

import {  Progress } from "antd";



import { useEffect, useState } from "react";

import { useToast } from "../../../../Components/Others/ToastServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import DeleteIcon from "../../../../Components/Icons/Delete";
import axiosInstance from "../../../../Services/axiosCommon";
import ViewIcon from "../../../../Components/Icons/ViewIcon";
import EditIcon from "../../../../Components/Icons/Edit";
import InSchedulelayout from "./InSchedulelayout";
import NuDate from "../../../../Components/Utils/NuDate";
import EditTaskAssignee from "./EditTaskAssignee";
import ViewTask from "./ViewTask";


function MyTask() {
  
  const navigate = useNavigate();

    const location = useLocation();
   
    const toast = useToast();
    const state = location.state;
  const {scheduleViewId}=useParams();
         const currentPage= location.state?.currentPage
      const searchQuery= location.state?.searchQuery
  
  
      const [tasks, setTasks] = useState([]);
        const [selectedTask, setSelectedTask] = useState(null);
        const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
        const [percentOpenTask, setPercentOpenTask] = useState(false);
        const [newCompletion, setNewCompletion] = useState(0);
        const [loading, setLoading] = useState(false);
      
        const [isEditModalOpen, setIsEditModalOpen] = useState(false);
        const [isViewModalOpen, setIsViewModalOpen] = useState(false);
      
        useEffect(() => {
          fetchTasks();
        }, []);
      
        const fetchTasks = async () => {
          try {
            setLoading(true);
            const response = await axiosInstance.get(`/calendar/tasks/${scheduleViewId}`);
            setTasks(response.data?.data);
          } catch (error) {
            console.error("Error fetching tasks:", error);
          } finally {
            setLoading(false);
          }
        };
      
       
        const handleUpdateCompletion = async () => {
          if (!selectedTask) return;
      
          try {
            setLoading(true);
            await axiosInstance.put(`/calendar/task-completion/${selectedTask.id}`, {
              taskCompletion: newCompletion,
            });
            fetchTasks();
            setPercentOpenTask(false);
          } catch (error) {
            console.error("Error updating task completion:", error);
          } finally {
            setLoading(false);
          }
        };
      
        const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
        const [itemToDelete, setItemToDelete] = useState(null);
      
         
        const cancelDelete = () => {
          setShowDeleteConfirm(false);
          setItemToDelete(null);
        };
        const handleDeleteClick = (id) => {
          setItemToDelete(id);
          setShowDeleteConfirm(true);
        };
        const confirmDelete = async (id) => {
          if (!itemToDelete) return;
      
          try {
            const res = await axiosInstance.delete(
              `/schedules/task/${selectedTask.id}`
            );
            if (res?.data?.status) {
              fetchTasks();
              toast.open({
                type: "success",
                message: "Success",
                description: res.data?.msg || "Deleted Successfully.",
              });
            } else {
              toast.open({
                type: "error",
                message: "Error",
                description: res.data.error || "Network error.",
              });
            }
          } catch (err) {
            toast.open({
              type: "error",
              message: "Error",
              description: err.response?.data?.error || "Delete failed.",
            });
          } finally {
            setShowDeleteConfirm(false);
            setItemToDelete(null);
          }
        };
       
  
    return (
    <>
     <InSchedulelayout
     >
    
        <div className="w-full h-full mt-0.5 ">
 
        
     {/* {screenSize.width<="786"?<MobileTask Data={data} getData={getData}  />: */}
      <div className=" w-full h-[calc(100vh-175px)] bg-white rounded-md overflow-hidden ">
        <div className="h-[calc(100vh-180px)] overflow-y-auto">
      
      <div className="overflow-x-auto ">
                   <table className="min-w-full border-separate border-spacing-y-2 text-xs text-left  ">
                     <thead className="border border-gray-50 ">
                       <tr className="font-semibold text-black">
                         <th className="px-4 py-2 text-left text-xs  w-[30%]">
                           Description
                         </th>
                         <th className="px-4 py-2 text-left text-xs  w-[10%]">
                           Date
                         </th>
                         <th className="px-4 py-2 text-left text-xs w-[15%]">
                           Assignee
                         </th>
                         <th className="px-4 py-2 text-left text-xs  w-[10%]">
                           Status
                         </th>
                         <th className="px-4 py-2 text-left text-xs w-[10%]">
                           Completion
                         </th>
                         <th className="px-4 py-2 text-left text-xs  w-[5%]">
                           Action
                         </th>
                       </tr>
                     </thead>
                     <tbody className=" rounded-md shadow-sm hover:bg-gray-50">
                       {tasks.map((task) => (
                         <tr key={task.id}>
                           <td className="px-4 py-3 whitespace-nowrap text-xs  w-[30%]">
                             {task.description || "N/A"}
                           </td>
                           <td className="px-4 py-3 whitespace-nowrap text-xs w-[10%]">
                             {task.date ? (
                               <NuDate value={task.date} format="DD-MMM-YYYY" />
                             ) : (
                               "N/A"
                             )}
                           </td>
                           <td className="px-4 py-3 whitespace-nowrap text-xs  w-[15%]">
                           {task.assignees?.length > 0 ? (
  <div className="flex flex-wrap gap-1">
    {task.assignees.map((assignee, index) => (
      <span
        key={index}
        className="inline-block text-xs "
      >
        {assignee.assigneeName || `Assignee ${index + 1}`}
        {index !== task.assignees.length - 1 && ','}
      </span>
    ))}
  </div>
) : (
  <span className="">Unassigned</span>
)}

                           </td>
                           <td className="px-4 py-3 whitespace-nowrap text-xs w-[10%]">
                             {task.status || "N/A"}
                           </td>
                           <td className="px-4 py-3 whitespace-nowrap text-xs w-[10%]">
                             <Progress
                               onClick={() => {
                                 setSelectedTask(task);
                                 setNewCompletion(task.taskCompletion || 0);
                                 setPercentOpenTask(true);
                               }}
                               type="circle"
                               size={30}
                               strokeWidth={12}
                               format={(percent) => (
                                 <span
                                   className={`cursor-pointer ${
                                     percent > 95
                                       ? "text-[#87d068]"
                                       : percent > 50
                                       ? "text-[#108ee9]"
                                       : "text-[#D2BD00]"
                                   } text-xs font-semibold`}
                                 >
                                   {percent}
                                 </span>
                               )}
                               percent={
                                 typeof task.taskCompletion === "number"
                                   ? task.taskCompletion
                                   : 0
                               }
                               strokeColor={
                                 (task.taskCompletion || 0) > 95
                                   ? { "0%": "#87d068", "100%": "#87d068" }
                                   : (task.taskCompletion || 0) > 50
                                   ? { "0%": "#108ee9", "100%": "#108ee9" }
                                   : { "0%": "#D2BD00", "100%": "#D2BD00" }
                               }
                             />
                           </td>
                           <td className="px-4 py-3 whitespace-nowrap text-sm font-medium">
                             <div className="flex gap-2">
                               {/* <span  className="flex justify-end"
                                 onClick={() => {
                                   setSelectedTask(task);
                                   setIsViewModalOpen(true);
                                 }}>
                                 <ViewIcon  color="Green"/>
                               </span> */}
                               <span
  className="flex justify-end cursor-pointer"
  onClick={() => {
    setSelectedTask(task);
    setIsViewModalOpen(true);
    navigate(`/inspection/schedule/viewtask/${task?.id}`,{
      state: {data:task},
    });
 }}
>
  <ViewIcon color="Green" />
</span>
                               <span
                                 className="flex justify-end"
                                 onClick={() => {
                                   setSelectedTask(task);
                                   setIsEditModalOpen(true);
                                 }}
                               >
                                 <EditIcon height="14" color="blue" />
                               </span>
     
                               <button
                                 className="text-red-500 hover:text-red-700 "
                                 onClick={() => handleDeleteClick(task)}
                                 disabled={loading}
                               >
                                 <DeleteIcon />
                               </button>
                             </div>
                           </td>
                         </tr>
                       ))}
                     </tbody>
                   </table>
                 </div>
      </div>
  {/* <div className=" h-6 my-2">
  <Pagination
    total={totalTasks}
    pageIndex={pageIndex}
    setPageIndex={setPageIndex}
    dataCount={dataCount}
    setDataCount={setDataCount}
  />
  </div> */}

  
  </div>
{/* //   } */}
  
  
       {showDeleteConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h3 className="text-sm font-medium mb-4">Warning</h3>
            <p className="mb-6 text-xs">
              Are you sure, you want to delete this Task?
            </p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={cancelDelete}
                className="px-4 py-[8px] text-xs hover:bg-gray-300 rounded-md flex items-center text-textColor-main bg-[#E6F2F2] cursor-pointer"
              >
                Cancel
              </button>
              <button
                onClick={confirmDelete}
                className="px-4 py-[8px] text-xs bg-textColor-main cursor-pointer rounded-md text-white"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
         {percentOpenTask && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[90%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Update Task Completion</h3>
              <button
                onClick={() => setPercentOpenTask(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ×
              </button>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Task Percentage
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={newCompletion}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (!isNaN(value) && value >= 0 && value <= 100) {
                      setNewCompletion(value);
                    }
                  }}
                  min={0}
                  max={100}
                  placeholder="0"
                />
                <span>%</span>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setPercentOpenTask(false)}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateCompletion}
                disabled={loading}
                className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
       {isEditModalOpen && (
              <EditTaskAssignee
                open={isEditModalOpen}
                onCancel={() => setIsEditModalOpen(false)}
                task={selectedTask}
                id={selectedTask?.id}
                fetchTasks={fetchTasks}
              />
            )}
             {isViewModalOpen && (
                  
                     <ViewTask
                      open={isViewModalOpen}
                      onCancel={() => setIsViewModalOpen(false)}
                      task={selectedTask}
                      id={selectedTask?.id}
                      fetchTasks={fetchTasks}
                    />     
                   
                    
                  )}
        </div>
        </InSchedulelayout>
      </>
    );
  }
  
  export default MyTask;
  
 
  